module.exports = __webpack_public_path__ + "static/media/skype-social-media-svgrepo-com (1).0a287dd2.svg";